import React from 'react';
import moment from 'moment-timezone';
import './PastShiftWarningModal.scss';
import { useSelector } from 'react-redux';
import BaseModal from './BaseModal/BaseModal';
import Utils from '../../utils/utils';
import { user } from '../../redux/user';
import GuaranteedIcon from '../icons/GuaranteedIcon';

const PastShiftWarningModal = ({ onConfirm, onClose, slot }) => {
	const userData = useSelector(user);
	const hasDisputePermission = Utils.isAuthorizedExact('PORTAL.DISPUTES', userData.permissions);

	return (
		<BaseModal
			confirmModalSize="lg"
			confirmNewModal
			title="Still want to approve this shift?"
			primaryActionLabel="Approve shift"
			secondaryActionLabel="Cancel"
			primaryActionDisabled={!hasDisputePermission}
			onPrimaryAction={onConfirm}
			onSecondaryAction={onClose}
			className="warning-past-shift-modal"
		>
			<p>
				This shift was flagged for your review. Please make sure you have reviewed the shift details before approving.
			</p>
			<br />
			<p>
				By approving this shift the hours recorded will be used or the scheduled start and end times will be populated
				as necessary. Continue anyway?
			</p>
			<br />
			<p className="shift-details-row">
				Professional:<b className="shift-detail">{slot.caregiver_name}</b>
			</p>
			<p className="shift-details-row">
				Shift details:
				<div className="shift-details">
					<b className="shift-detail">{moment.utc(slot.raw_start_time).format('ddd, MMM D, YYYY')}</b>
					<b className="shift-detail">
						{slot.start_time} - {slot.end_time}
					</b>
					{slot.is_guaranteed && (
						<p className="shift-detail">
							<div className="guaranteed-badge">
								<GuaranteedIcon /> Guaranteed
							</div>
						</p>
					)}
				</div>
			</p>
			<p className="shift-details-row">
				Shift type:<b className="shift-detail">{slot.resource_type}</b>
			</p>
		</BaseModal>
	);
};

export default PastShiftWarningModal;
